<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">

        <el-col :span="12">
          <el-form-item label="Bina">
            <el-switch
                v-model="Form.bina"
                active-color="#13ce66"
                inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="Form.turu?'Satış Faturası':'Alış Faturası'">
            <el-switch
                v-model="Form.turu"
                active-color="#13ce66"
                inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-if="Form.bina!=true">
          <el-form-item label="Cari" prop="Cari_id">
            <el-select v-model="Form.Cari_id" filterable placeholder="Cari Seçiniz">
              <el-option
                  v-for="item in Cariler"
                  :key="item.id"
                  :label="item.adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-if="Form.bina==true">
          <el-form-item label="Bina" prop="Bina_id">
            <el-select v-model="Form.Bina_id" filterable placeholder="Bina Seçiniz">
              <el-option
                  v-for="item in Binalar"
                  :key="item.id"
                  :label="item.adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="Açıklama" prop="aciklama">
            <el-input type="textarea" v-model="Form.aciklama" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">Fatura Ürünleri</el-divider>
      <el-col :span="24">

        <table class="table table-hover mb-4">
          <thead class="bg-gray-300">
          <tr>
            <th>#</th>
            <th>Ürun</th>
            <th>Miktar</th>
            <th>Fiyat</th>
            <th>Toplam</th>
            <th>
              <el-button class="btn-primary" size="mini" type="button" @click="addInput">Satır Ekle</el-button>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(input, key) in Form.Urun" :key="input.id">
            <td>{{ input.id }}</td>
            <td>
              <el-select v-model="input.info" value-key="id" @change="bilgi(key)">
                <el-option
                    v-for="item in Urunler"
                    :key="item.id"
                    :label="item.adi"
                    :value="{id:item.id,money:item.sfiyat}"></el-option>
              </el-select>
            </td>
            <td>
              <el-input type="text" maxlength="12" show-word-limit v-model.number="input.miktar"
                        :change="calculate(input,key)"></el-input>
            </td>
            <td>
              <el-input type="text" :precision="2" :step="0.1" show-word-limit
                        v-model="input.fiyat"></el-input>
            </td>
            <td>
              <el-input type="text" :precision="2" :step="0.1" show-word-limit
                        v-model="input.toplam" disabled=""></el-input>
            </td>
            <td>
              <el-button class="btn-primary" size="mini" type="button" @click="Sil(key)" v-if="key!=0">Satır Sil
              </el-button>
            </td>
          </tr>

          </tbody>
        </table>

      </el-col>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['Bilgi', 'Durum', 'Tur'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: {
        bina: false,
        turu: false,
        Cari_id: '',
        Bina_id: '',
        Urun: [{
          id: '1',
          Urun_id: '',
          miktar: 1,
          fiyat: '0',
          toplam: 0,
        }],
        toplam: 0,
      },
      Cariler: null,
      Binalar: null,
      Urunler: null,
      FormHata: {
        adi: [{required: true, message: "Fatura Adı Giriniz", trigger: 'blur'}],
        Bolge_id: [{required: true, message: "Bölge Seçiniz", trigger: 'blur'}],
        adres: [{required: true, message: "Adres Giriniz", trigger: 'blur'}],
      },
      counter: 1,
    }
  },
  methods: {
    calculate(input, key) {
      this.Form.Urun[key].toplam = input.miktar * input.fiyat;
      var Total = this.Form.Urun.reduce((acc, item) => acc + Number(item.toplam), 0);
      this.Form.toplam = Total;
    },
    addInput() {
      this.Form.Urun.push({
        id: `${++this.counter}`,
        Urun_id: '',
        miktar: '1',
        fiyat: '0',
      });
    },
    Sil(index) {
      this.$delete(this.Form.Urun, index);
    },
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true

          this.$store.dispatch(this.Tur, {...this.Form, path: 'fatura'})
              .then(response => {
                console.log(response)
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  this.Form.bina = false;
                  this.Form.turu = false;
                  this.Form.Cari_id = '';
                  this.Form.Bina_id = '';
                  this.Form.Urun[0].id=1;
                  this.Form.Urun[0].Urun_id='';
                  this.Form.Urun[0].miktar=1;
                  this.Form.Urun[0].fiyat='0';
                  this.Form.Urun[0].toplam='0';
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    },


    Cari() {
      this.$store.dispatch("Get", {path: 'cari'})
          .then(response => {
            this.Cariler = response.Data
          })
    },

    Bina() {
      this.$store.dispatch("Get", {path: 'build'})
          .then(response => {
            this.Binalar = response.Data
          })
    },

    UrunListele() {
      this.$store.dispatch("Get", {path: "urun"})
          .then(response => {
            if (response.Durum == 'OK') {
              this.Urunler = response.Data;
            }
          });
    },

    bilgi(key) {
      console.log(key);
      this.Form.Urun[key].Urun_id = (this.Form.Urun[key].info.id)
      this.Form.Urun[key].fiyat = (this.Form.Urun[key].info.money.replace(',', '.'))
      this.Form.Urun[key].toplam = (this.Form.Urun[key].miktar)
    },


  },
  created() {
    if (this.Bilgi) {
      this.Form = this.Bilgi
      this.ModalBaslik = this.Bilgi.Unvan
    } else {
      this.Form.bina = false;
      this.Form.turu = false;
      this.Form.Cari_id = '';
      this.Form.Bina_id = '';
      this.Form.Urun[0].id=1;
      this.Form.Urun[0].Urun_id='';
      this.Form.Urun[0].miktar=1;
      this.Form.Urun[0].fiyat='0';
      this.Form.Urun[0].toplam='0';

      this.ModalBaslik = 'Fatura Ekle'
    }
    this.Cari();
    this.Bina();
    this.UrunListele();
    console.log(this.Form.Urun);
  },
  watch: {
    Bilgi: function () {
      this.Form = this.Bilgi
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/fatura/Comp/yeni.vue